import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">About KADIBIA BEAUTY</h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <p className="text-xl text-gray-600 mb-6">
            KADIBIA BEAUTY is your premier destination for high-quality skincare and beauty solutions. We specialize 
            in providing authentic foreign skin care products, expert skincare consultation, and professional makeup services.
            Our passion lies in helping you achieve and maintain your desired beauty goals.
          </p>
          <p className="text-xl text-gray-600">
            Located at Whitesand Beach Estate Ologolo, we combine professional expertise with premium products 
            to deliver exceptional beauty services that enhance your natural radiance.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gray-50 p-8 rounded-lg">
            <h4 className="text-xl font-bold text-gray-900 mb-4">Services</h4>
            <ul className="space-y-3 text-gray-600">
              <li>Skincare Consultation <span className="block text-sm text-gray-500">Personalized Assessment & Recommendations</span></li>
              <li>Makeup Services <span className="block text-sm text-gray-500">Professional Application & Training</span></li>
              <li>Beauty Products <span className="block text-sm text-gray-500">Foreign Skincare & Makeup Products</span></li>
              <li>Makeup Training <span className="block text-sm text-gray-500">Individual & Group Sessions</span></li>
              <li>Beauty Advisory <span className="block text-sm text-gray-500">Personalized Beauty Tips & Guidance</span></li>
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg">
            <h4 className="text-xl font-bold text-gray-900 mb-4">Products</h4>
            <ul className="space-y-3 text-gray-600">
              <li>
                <span className="hover:text-gray-900">
                  Skincare Products
                  <span className="block text-sm text-gray-500">Premium Foreign Brands</span>
                </span>
              </li>
              <li>
                <span className="hover:text-gray-900">
                  Makeup Collection
                  <span className="block text-sm text-gray-500">Professional Grade Products</span>
                </span>
              </li>
              <li>
                <span className="hover:text-gray-900">
                  Beauty Tools
                  <span className="block text-sm text-gray-500">Professional Application Tools</span>
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg">
            <h4 className="text-xl font-bold text-gray-900 mb-4">Expertise</h4>
            <ul className="space-y-3 text-gray-600">
              <li>Skincare Consultation</li>
              <li>Makeup Artistry</li>
              <li>Beauty Education</li>
              <li>Product Knowledge</li>
              <li>Skin Analysis</li>
              <li>Beauty Transformation</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;